import React from "react"

import ListItem from "./_ListItem"

function ProductList({ slug, subcategoryList }) {
  return (
    <section id="product-list" className="pt-6 wrapper">
      <ul className="default-grid gap-y-14 md:gap-y-8">
        {subcategoryList?.map((subcategory, i) => (
          <ListItem
            categorySlug={slug}
            {...subcategory}
            key={`subcategory--${i}`}
          />
        ))}
      </ul>
    </section>
  )
}

export default ProductList
